import { useContext, useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
import { toast } from 'react-toastify'

import { useSigninMutation, useSigninEntityMutation, IdentiaEntity } from './../../store/api/identia'
import { types } from './../../context/types/types'
import { typeUi } from './../../context/types/typesui'
import { AuthContext } from '../../context/auth/AuthProvider'
import { IEntity } from '../../context/auth/AuthInterface'
import { AparienciaContext } from '../../context/aparienciaContext/AparienciaProvider'
import { getEntityTheme, userIsInEntities } from '../../context/entityContext/EntityAction'
import CardAccess from './CardAccess'

const LoginPage = () => {
    const history = useHistory()

    const { dispatch } = useContext(AuthContext)
    const { dispatchImg } = useContext(AparienciaContext)
    const [signin] = useSigninMutation()
    const [signinEntity] = useSigninEntityMutation()
    // const { dispatch: dispacthEvent } = useContext(AparienciaContext);
    // console.log(dispatchImg)

    const [user, setUser] = useState({
        username: '',
        password: '',
    })

    // const [userLogged, setUserLogged] = useState({})

    const { username, password } = user

    const [showPassword, setShowPassword] = useState<boolean>(false)
    const [loading, setLoading] = useState<boolean>(false) 

    // const [role, setRole] = useState('')

    const [msgError, setMsgError] = useState<any>({
        // fields: {},
        errors: {},
    })

    let data: any = {
        title: 'Iniciar sesión como:',
        name: 'Administrador',
        info: 'Para ingresar a la plataforma debe poner sus credenciales de acceso.',
    }

    const onChangeInputs = (e: any) => {
        setUser({
            ...user,
            [e.target.name]: e.target.value,
        })
    }

    const handleValidation = () => {
        // let fields = msgError.fields;
        let errors = {
            email: '',
            password: '',
        }
        let formIsValid = true

        //Email
        if (!username) {
            formIsValid = false
            errors['email'] = 'El email es obligatorio'
        }

        if (!password) {
            formIsValid = false
            errors['password'] = 'La contraseña es obligatoria'
        }

        if (password.length < 6) {
            formIsValid = false
            errors['password'] = 'La contraseña tiene que tener mas de 6 carácteres'
        }

        setMsgError({ errors: errors })
        return formIsValid
    }

    const handleLogin = async (e: any) => {
        e.preventDefault()

        setLoading(true)

        if (handleValidation()) {
            try {
                const info = await signin({
                    userType: 'person',
                    base: 'multiedu',
                    credentials: {
                        typeCredential: 'email',
                        credential: username,
                        password: password,
                    },
                }).unwrap()

                if (info.roles && info.roles[0] === 'superadmin') {
                    setLoading(false)

                    dispatchImg({
                        type: typeUi.getTheme,
                        payload: {
                            colorSidebar: {
                                bg_sidebar: '#0E3873',
                                bg_buttons: '#0E3873',
                                font_color: '#ffffff',
                            },
                            imgLogo:
                                'https://res.cloudinary.com/khail/image/upload/v1623334250/Logo_vr_1_1_vvji7m.png',
                        },
                    })

                    dispatch({
                        type: types.login,
                        payload: {
                            username: info.user.attributes?.email || '',
                            rol: 'superadmin',
                            main_rol: 'superadmin',
                            token: info.token || '',
                            idUser: info.user.id || '',
                            rolesByEntity: info.roles || [],
                            dataEntity: {
                                customize: {
                                    colors: {
                                        bg_sidebar: '#197BFF',
                                        bg_buttons: '#197BFF',
                                        font_color: '#ffffff',
                                    },
                                    logo: 'https://res.cloudinary.com/khail/image/upload/v1623334250/Logo_vr_1_1_vvji7m.png',
                                    portrait:
                                        'https://playtecacademy.s3.us-east-2.amazonaws.com/entities/Rectangle%203072.png',
                                },
                            },
                            platform: info.platform || { id: '', platform_name: '', alias: '', description: '' },
                            listEntity: [],
                            user: {
                                _id: info.user.id || '',
                                username: info.user.attributes?.username || '',
                                email: info.user.attributes?.email || '',
                            },
                        },
                    })
                } else {
                    const first = (info.entities && info.entities.length && info.entities[0]) || null
                    const entityId = first && first.id

                    if (!entityId) {
                        setLoading(false)
                        toast.error('No tienes acceso a esta entidad')
                        return
                    }

                    try {
                        const infoEnt = await signinEntity({ entity: entityId, token: info.token }).unwrap()
                        userIsInEntities(infoEnt.token, infoEnt.user.id).then(({ data }) => {
                            console.log('QUE ENTIDADES ESTAS', data)

                        }).catch((err: any) => {
                            console.error('Error verificando entidades del usuario', err)
                        })
                        console.log('infoEnt', infoEnt)
                        const tokenEnt = infoEnt.token
                        const rawEntities = infoEnt.entities || []
                        const firstEntity = (rawEntities.length && rawEntities[0])

                        const firstEntityId = (firstEntity && (firstEntity.id)) || null
                        if (!firstEntityId) {
                            setLoading(false)
                            console.error('No firstEntity id returned from signinEntity', infoEnt)
                            toast.error('Error interno: entidad inválida')
                            return
                        }

                        const themeRes = await getEntityTheme(tokenEnt, firstEntityId)
                        const themeData = themeRes && (themeRes as any).data
                        const customize = (themeData && themeData.customize) || {
                            logo: '/images/login/playtec.svg',
                            portrait: '',
                            colors: { bg_sidebar: '#197BFF', bg_buttons: '#197BFF', font_color: '#ffffff' },
                        }

                        const normalizeRoles = (r: any) => {
                            const rolesArr: string[] = Array.isArray(r)
                                ? r
                                : Object.entries(r || {})
                                      .filter(([, val]) => !!val)
                                      .map(([key]) => key)

                            return {
                                counter: rolesArr.includes('counter'),
                                admin: rolesArr.includes('admin'),
                                coordinador: rolesArr.includes('coordinador'),
                                estudiante: rolesArr.includes('estudiante'),
                                docente: rolesArr.includes('docente'),
                            }
                        }

                        const toIEntity = (ent: IdentiaEntity): IEntity => ({
                            _id: ent.id ||  '',
                            entity_name: ent.brand_name,
                            description: ent.legal_name,
                            admin: infoEnt.user.id || '',
                            domain: ent.domain || '',
                            user: infoEnt.user.id || '',
                            roles: normalizeRoles(infoEnt.roles || {}),
                            customize: customize,
                        })

                        const entitiesEnt: IEntity[] = rawEntities.map((ent: any) => toIEntity(ent))
                        const firstEntityI = firstEntity ? toIEntity(firstEntity) : entitiesEnt[0]

                        console.log('firstEntityI', firstEntityI)
                        console.log('entitiesEnt', entitiesEnt)

                        setLoading(false)
                        toast.dismiss()
                        toast.success(`Bienvenido ${username}`)

                        dispatchImg({
                            type: typeUi.getTheme,
                            payload: {
                                colorSidebar: customize.colors,
                                imgLogo: customize.logo || '/images/login/playtec.svg',
                            },
                        })

                        dispatchImg({
                            type: typeUi.getId,
                            payload: firstEntityId,
                        })

                        const rolesInfo = infoEnt.roles || []
                        const hasRole = (r: string) =>
                            Array.isArray(rolesInfo) ? rolesInfo.includes(r) : !!rolesInfo[r]

                        if (hasRole('coordinador')) {
                            dispatch({ type: types.changeRoles, payload: 'coordinador' })
                            dispatch({
                                type: types.login,
                                payload: {
                                    username: infoEnt.user.attributes?.email || '',
                                    rol: 'user',
                                    main_rol: 'coordinador',
                                    token: tokenEnt || '',
                                    idUser: infoEnt.user.id || '',
                                    rolesByEntity: firstEntityI.roles || {},
                                    dataEntity: firstEntityI,
                                    listEntity: entitiesEnt || [],
                                       platform: infoEnt.platform || info.platform || { id: '', platform_name: '', alias: '', description: '' },
                                    user: {
                                        _id: infoEnt.user.id || '',
                                        username: infoEnt.user.attributes?.username || '',
                                        email: infoEnt.user.attributes?.email || '',
                                    },
                                },
                            })

                            history.push('/dashboard/coordinator/courses')
                        }

                        if (hasRole('counter')) {
                            dispatch({ type: types.changeRoles, payload: 'counter' })
                            dispatch({
                                type: types.login,
                                payload: {
                                    username: infoEnt.user.attributes?.email || '',
                                    rol: 'user',
                                    main_rol: 'counter',
                                    token: tokenEnt || '',
                                    idUser: infoEnt.user.id || '',
                                    rolesByEntity: firstEntityI.roles || {},
                                    dataEntity: firstEntityI,
                                    listEntity: entitiesEnt || [],
                                       platform: infoEnt.platform || info.platform || { id: '', platform_name: '', alias: '', description: '' },
                                    user: {
                                        _id: infoEnt.user.id || '',
                                        username: infoEnt.user.attributes?.username || '',
                                        email: infoEnt.user.attributes?.email || '',
                                    },
                                },
                            })

                            history.push('/dashboard/accountant/students/inscribed')
                        }

                        if (hasRole('admin')) {
                            dispatch({ type: types.changeRoles, payload: 'admin' })
                            dispatch({
                                type: types.login,
                                payload: {
                                    username: infoEnt.user.attributes?.email || '',
                                    rol: 'admin_entity',
                                    main_rol: 'admin',
                                    token: tokenEnt || '',
                                    idUser: infoEnt.user.id || '',
                                    rolesByEntity: firstEntityI.roles || {},
                                    dataEntity: firstEntityI,
                                    listEntity: entitiesEnt || [],
                                       platform: infoEnt.platform || info.platform || { id: '', platform_name: '', alias: '', description: '' },
                                    user: {
                                        _id: infoEnt.user.id || '',
                                        name: infoEnt.user.attributes?.name || '',
                                        lastname: infoEnt.user.attributes?.lastname || '',
                                        email: infoEnt.user.attributes?.email || '',
                                        photo: infoEnt.user.attributes?.photo || '',
                                    },
                                },
                            })

                            history.push('/dashboard/admin/courses')
                        }
                    } catch (err) {
                        setLoading(false)
                        console.error(err)
                        toast.error('Error al seleccionar la entidad')
                    }
                }
            } catch (e) {
                setLoading(false)
                console.log(e)
                toast.error('Revisa tu usuario o contraseña e intenta de nuevo')
            }
        } else {
            setLoading(false)
        }
    }

    return (
        <div className="main_AccessPage">
            <CardAccess data={data}>
                <form onSubmit={handleLogin}>
                    <div className="formBody">
                        <label htmlFor="accessUser">
                            <input
                                id="accessUser"
                                type="email"
                                name="username"
                                placeholder="Ingrese su correo"
                                value={username}
                                onChange={onChangeInputs}
                                disabled={loading}
                                required
                            />
                        </label>
                        <span style={{ color: 'red' }}>{msgError.errors['email']}</span>
                        <span>
                            <Link to="/auth/recover-password">
                                ¿Olvidó su contraseña?
                            </Link>
                        </span>
                        <label htmlFor="accessPass">
                            <input
                                id="accessPass"
                                className="inpPass"
                                type={`${showPassword ? 'text' : 'password'}`}
                                placeholder="Contraseña"
                                name="password"
                                value={password}
                                onChange={onChangeInputs}
                                disabled={loading}
                                required
                            />
                            <i
                                className={`far fa-eye${showPassword ? '-slash' : ''}`}
                                onClick={() => setShowPassword(!showPassword)}
                            />
                        </label>
                        <span style={{ color: 'red' }}>
                            {msgError.errors['password']}
                        </span>
                    </div>
                    <div className="formFooter">
                        {loading ? (
                            <button style={{ backgroundColor: '#8CBDFF' }} disabled>
                                CARGANDO...
                            </button>
                        ) : (
                            <button>INICIAR SESIÓN</button>
                        )}
                    </div>
                </form>
            </CardAccess>
        </div>
        //  <div className="floating_button">
        //                     <i className="fas fa-headphones"></i>
        //  </div>
    )
}

export default LoginPage
